module.exports = __webpack_public_path__ + "media/images/pic/courses/1-ee6d352005d77499dff20db559331011.jpeg";